export default "__VITE_ASSET__09bf7be3__"